module.exports = __webpack_public_path__ + "static/media/video-icon.2cf887e2.svg";